import { motion } from "framer-motion";
import { Card } from "@/components/ui/card";
import { Wallet } from "lucide-react";
import { Expense } from "@/types/expense";

interface QuickStatsProps {
  expenses: Expense[];
  categoryTotals: Record<string, number>;
  totalExpenses: number;
}

export const QuickStats = ({ expenses, categoryTotals, totalExpenses }: QuickStatsProps) => {
  return (
    <Card className="p-4 bg-gradient-to-br from-white to-gray-50">
      <div className="flex items-center gap-2 mb-4">
        <Wallet className="h-5 w-5 text-primary" />
        <h3 className="font-semibold">Quick Stats</h3>
      </div>
      <motion.div 
        className="space-y-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
      >
        <div className="flex justify-between items-center">
          <span className="text-sm text-muted-foreground">Categories</span>
          <span className="font-medium">{Object.keys(categoryTotals).length}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-sm text-muted-foreground">Avg. Transaction</span>
          <span className="font-medium">₹{(totalExpenses / expenses.length).toFixed(2)}</span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-sm text-muted-foreground">Total Transactions</span>
          <span className="font-medium">{expenses.length}</span>
        </div>
      </motion.div>
    </Card>
  );
};